export default __webpack_public_path__ + "static/media/PharamcyManagement.64674ce1.svg";